import { SearchFilterDayTimeType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-day-time.type';
import { SearchApiDayTime } from '@/app/(main)/(pages)/_types/search-api-response.type';

const SEARCH_API_DAY_TIME: Partial<Record<SearchFilterDayTimeType, SearchApiDayTime>> = {
  [SearchFilterDayTimeType.MORNING]: 'MORNING',
  [SearchFilterDayTimeType.AFTERNOON]: 'AFTERNOON',
};

export function toSearchApiDayTime(dayTime?: SearchFilterDayTimeType): SearchApiDayTime | undefined {
  return dayTime ? SEARCH_API_DAY_TIME[dayTime] : undefined;
}
